import { SiteCreate } from '~/modules/sites';
import dashboardWrapper from '~/wrappers/dashboard';
import { t } from '~/i18n';

export default dashboardWrapper(SiteCreate, t('menu.dashboard.settingsSites'));
